import { CONFIG } from "~/config";
import { _ } from "~/i18n";
import Scene from "~/scene";
import { store } from "~/state/store";
import { setMapset } from "~/state/map/state";
import { watch, watchDetail } from "~/state/util";

export async function editorialLoad() {
	if (Mapy.CUS.editorial?.interface === 1) {
		const module = await import(
			/* webpackChunkName: "editorial" */
			"~/editorial/main"
		);

		// nastavime
		module.initModule({
			CONFIG,
			Scene,
			_,
			store,
			mySetMapset: (mapset: string) => {
				store.dispatch(setMapset({ mapset }));
			},
			myGetMapset: () => store.getState().map.mapset,
			bindDetailChange: onDetailChange => {
				const wtDetail = watch(store.getState, "detail", watchDetail);

				// zmena dat detailu
				store.subscribe(wtDetail((newDetail, oldDetail) => {
					if (newDetail.data !== oldDetail.data) {
						onDetailChange(newDetail.data, newDetail.centerZoom);
					}
				}));
			},
		});
		// vytvorime
		const detailState = store.getState().detail;

		/* eslint-disable-next-line */
		new module.default(detailState.data, detailState.centerZoom);
	}
}
